import React from "react";
import { Box, Typography, IconButton, Badge, Divider } from "@mui/material";
import UnreadCountBadge from "./UnreadCountBadge";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { FONT_SIZE } from "../../constants/fontSizes";

export default function HeaderUnreadButtons({
  isDesktop,
  onOpen,
  projectUnreadCount = 0,
  jobUnreadCount = 0,
  totalUnreadCount = 0,
}) {
  return isDesktop ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <IconButton
        onClick={() => onOpen("projects")}
        sx={{
          borderRadius: 2,
          px: 1.5,
          color: "#1e3a8a",
          transition:
            "transform 300ms ease, color 300ms ease, background-color 300ms ease",
          "&:hover": {
            bgcolor: "transparent", // HeaderMenuItemは背景変えないので合わせる
            color: "#0f2a6d",
            transform: "translateY(-2px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1,
          }}
        >
          {/* アイコン（hoverで拡大） */}
          <Box
            sx={{
              display: "inline-flex",
              transition: "transform 300ms ease",
              ".MuiIconButton-root:hover &": { transform: "scale(1.1)" },
            }}
          >
            <UnreadCountBadge count={projectUnreadCount}>
              <AssignmentOutlinedIcon sx={{ fontSize: 22 }} />
            </UnreadCountBadge>
          </Box>

          {/* ラベル（hoverで色＋下線アニメ） */}
          <Typography
            sx={{
              fontSize: FONT_SIZE.XS,
              mt: 0.25,
              whiteSpace: "nowrap",
              color: "black",
              position: "relative",
              transition: "color 300ms ease",
              ".MuiIconButton-root:hover &": { color: "#0f2a6d" },
              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: -3,
                width: 0,
                height: 1.5,
                backgroundColor: "#0f2a6d",
                transition: "all 300ms ease",
              },
              ".MuiIconButton-root:hover &::after": {
                left: 0,
                width: "100%",
              },
            }}
          >
            未読プロジェクト
          </Typography>
        </Box>
      </IconButton>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <IconButton
        onClick={() => onOpen("jobs")}
        sx={{
          borderRadius: 2,
          px: 1.5,
          color: "#1e3a8a",
          transition:
            "transform 300ms ease, color 300ms ease, background-color 300ms ease",
          "&:hover": {
            bgcolor: "transparent",
            color: "#0f2a6d",
            transform: "translateY(-2px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1,
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              transition: "transform 300ms ease",
              ".MuiIconButton-root:hover &": { transform: "scale(1.1)" },
            }}
          >
            <UnreadCountBadge count={jobUnreadCount}>
              <ApartmentOutlinedIcon sx={{ fontSize: 22 }} />
            </UnreadCountBadge>
          </Box>

          <Typography
            sx={{
              fontSize: FONT_SIZE.XS,
              mt: 0.25,
              whiteSpace: "nowrap",
              color: "black",
              position: "relative",
              transition: "color 300ms ease",
              ".MuiIconButton-root:hover &": { color: "#0f2a6d" },
              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: -3,
                width: 0,
                height: 1.5,
                backgroundColor: "#0f2a6d",
                transition: "all 300ms ease",
              },
              ".MuiIconButton-root:hover &::after": {
                left: 0,
                width: "100%",
              },
            }}
          >
            未読求人
          </Typography>
        </Box>
      </IconButton>
    </Box>
  ) : (
    <IconButton sx={{ color: "#545454", p: 1.5 }} onClick={() => onOpen()}>
      {(() => {
        // 未読が0件ならバッジを非表示にする
        const invisible = totalUnreadCount === 0;

        return (
          <Badge
            variant="dot"
            color="error"
            overlap="circular"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            invisible={invisible}
            sx={{
              "& .MuiBadge-badge": {
                height: "12px",
                minWidth: "12px",
                borderRadius: "50%",
                transform: "translate(40%, -40%)",
              },
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              width="25"
              height="25"
              fill="currentColor"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M155.8 96C123.9 96 96.9 119.4 92.4 150.9L64.6 345.2C64.2 348.2 64 351.2 64 354.3L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 354.3C576 351.3 575.8 348.2 575.4 345.2L547.6 150.9C543.1 119.4 516.1 96 484.2 96L155.8 96zM155.8 160L484.3 160L511.7 352L451.8 352C439.7 352 428.6 358.8 423.2 369.7L408.9 398.3C403.5 409.1 392.4 416 380.3 416L259.9 416C247.8 416 236.7 409.2 231.3 398.3L217 369.7C211.6 358.9 200.5 352 188.4 352L128.3 352L155.8 160z" />
            </svg>
          </Badge>
        );
      })()}
    </IconButton>
  );
}
